var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "w-100", attrs: { "min-height": "365px" } },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "120" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-title",
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c("v-icon", { staticClass: "pr-2", attrs: { large: "" } }, [
                _vm._v("mdi-calendar-today"),
              ]),
              _c("h3", [_vm._v(_vm._s(_vm.$t("publicHolidayManagement")))]),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-card-text", [
        _c(
          "div",
          { staticClass: "d-flex justify-center" },
          [
            _c(
              "v-col",
              { attrs: { cols: "7" } },
              [
                _c("v-select", {
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    height: "20px",
                    items: _vm.states,
                    "item-text": "name",
                    "item-value": "value",
                  },
                  model: {
                    value: _vm.selectedState,
                    callback: function ($$v) {
                      _vm.selectedState = $$v
                    },
                    expression: "selectedState",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "d-flex justify-center" },
          [
            _c(
              "v-col",
              { attrs: { cols: "4" } },
              [
                _c("v-text-field", {
                  attrs: {
                    label: _vm.$t("year"),
                    "prepend-icon": "mdi-calendar",
                    type: "number",
                  },
                  model: {
                    value: _vm.selectedYear,
                    callback: function ($$v) {
                      _vm.selectedYear = $$v
                    },
                    expression: "selectedYear",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          [
            _c("v-data-table", {
              staticStyle: { "min-height": "240px" },
              attrs: {
                items: _vm.publicHolidays,
                "hide-default-header": "",
                headers: _vm.holidaysTableHeader,
                "hide-default-footer": "",
                page: _vm.page,
                "items-per-page": _vm.itemsPerPage,
              },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "page-count": function ($event) {
                  _vm.pageCount = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.date",
                  fn: function ({ item }) {
                    return [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$moment(item.date).format("DD.MM.YYYY")
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c(
              "div",
              { staticClass: "text-center pt-2" },
              [
                _c("v-pagination", {
                  attrs: { length: _vm.pageCount },
                  model: {
                    value: _vm.page,
                    callback: function ($$v) {
                      _vm.page = $$v
                    },
                    expression: "page",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "v-card-actions",
        [
          _c(
            "v-row",
            { attrs: { justify: "end", "no-gutters": "" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "mr-2 mb-2",
                  staticStyle: { color: "white" },
                  attrs: { rounded: "", color: "#990000" },
                  on: {
                    click: function ($event) {
                      _vm.showHolidayDialog = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("importHolidays")))]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-2 mb-2",
                  staticStyle: { color: "white" },
                  attrs: { rounded: "", color: "#990000" },
                  on: {
                    click: function ($event) {
                      _vm.showHolidayAdministration = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("editPublicHolidays")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showHolidayDialog
        ? _c("HolidayImportDialog", {
            attrs: {
              state: _vm.selectedState,
              sapHolidays: _vm.allHolidays,
              year: _vm.selectedYear,
            },
            on: {
              close: function ($event) {
                ;(_vm.showHolidayDialog = false),
                  (_vm.selectedYear = $event.selectedYear),
                  (_vm.selectedState = $event.selectedLand)
              },
              importHolidayDays: _vm.getHolidays,
            },
          })
        : _vm._e(),
      _vm.showHolidayAdministration
        ? _c("HolidaysAdministration", {
            attrs: { state: _vm.selectedState, year: _vm.selectedYear },
            on: {
              close: function ($event) {
                return _vm.closeHolidayAdministration($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }